/* Converts an object to an array of it's properties */ // todo [mandy] extract this to somewhere more common?
export function objectToArray(ruleVariables) {
    let variables = [];
    for (let variable in ruleVariables) {
        if (ruleVariables.hasOwnProperty(variable)) {
            // variables.push(ruleVariables[variable]);

            variables.push({ name: variable, value: ruleVariables[variable] });
        }
    }

    return variables;
}
